import { lazy, Suspense } from "react";
import { routes } from "routing";
import { LazyFallback, lazyView, view, type RouteRender } from "routing/tree";
import { FilterProvider } from "state/FilterProvider";

const { team } = routes;

// TeamPage stays code-split (it is a tab root). The wrapper supplies the FilterProvider
// and Suspense boundary the tab route needs.
const TeamPage = lazy(() => import("./team"));

export const TeamPageWithFilter = () => (
  <Suspense fallback={<LazyFallback />}>
    <FilterProvider>
      <TeamPage />
    </FilterProvider>
  </Suspense>
);

/**
 * The team area's route tree.
 *
 * The team root is split out from the sub-pages: it keeps the home-tab layout (the
 * itinerary carousel + profile/org gates that HomeRoutes provides), so routes.tsx
 * renders `teamRootRoutes` under HomeRoutes and `teamSubRoutes` standalone. The full
 * `teamRoutes` list is exported for all-routes.ts (native bar titles).
 */
export const teamRootRoutes: RouteRender[] = [view(team.page, TeamPageWithFilter, "Team")];

// Code-split: team-member.tsx constructs a `new LngLat`, pulling in maplibre-gl.
export const teamSubRoutes: RouteRender[] = [
  lazyView(team.search, () => import("./search/team-search").then((m) => ({ default: m.TeamSearchPage })), "Search"),
  lazyView(team.categories, () => import("./categories/team-categories"), "Categories"),
  lazyView(team.member, () => import("./members/team-member").then((m) => ({ default: m.TeamMemberPage })), ""),
];

export const teamRoutes: RouteRender[] = [...teamRootRoutes, ...teamSubRoutes];
